
import { ITableItem, ITableDate, IBookingTime } from "shared-types/index";


export interface ITableSeater extends IProps, IHandlers {}

export interface IBaseProps {
  isWhiteTheme?: boolean; // this adds extra whiteness when useReversedColors is true
  useReversedColors?: boolean; // assumes the component is sitting on a dark colour, so all text, borders, etc are white
  manualJoinType?: ManualJoinType; // lock to a manualJoin or noJoin tyoe. If omitted the manualJoin button will appear
  label?: string;
  showEmptyTableValidationMessage?: boolean;
  classPrefix: string;
  showUnderline?:boolean;
  isLockedBooking?: boolean;
}

/**
 * Properties passed directly into the react component. If the container is responsible for fetching async data, via a
 * service, these may differ from IContainerProps.
 */
export interface IIncompleteTableSeaterProps extends IBaseProps {
  tableSelectionList: ITableItem[];
  tableSelectionListWithJoins: ITableItem[];
  // sectionsLookup: any; // gets added inside TableSelectionService.getTableSeaterProps
  preselectedTableIds: string[];
  isModalStyle?: boolean;
  isWideModal?: boolean;
  isWideVersion?: boolean;
  isDisplayErrMsg?: boolean;
  handleBeforeOpen?: () => Promise<void>;
}

export interface IProps extends IIncompleteTableSeaterProps {
  sectionsLookup: any; // object with dynamic keys
  usePreselectedTableIds?: boolean
}



export interface ITableParams {
  isDropdownOpen?: boolean;
  returnToParent?: () => void;
  isTypeRecurring?: boolean;
  isDisabled?: boolean;
  isMobile?: boolean;
}

export interface ITableSelectionListItem extends ITableItem {
  isAltBg?: boolean;
}

export interface ITableDividerHeader extends ITableSelectionListItem {
  isDivider?: boolean;
}


export interface ITableSeaterContainerProps extends IBaseProps {
  selectedTime: IBookingTime; // removed ITableDate because the data does not actually seem to be extending Date
  tables: ITableItem[]; // list of tables from selected service
  selectedTableIds: string[];
  handleUpdate: (selectedTableIds: string[], tables: ITableItem[], isManualJoin: boolean) => void;
}

export interface IAutoTableSeaterProps {
  isShowLegend?: boolean, // displays the legend below (you can get this from the Group Widget / ABC)
  isShowTableIcon?: boolean, // displays the table icon to the left
  isHideUnderline?: boolean, // hides the line under the selected table
  isShowPlaceholder?: boolean, // text to appear when nothing selected (pass in “Auto-select table“) from parent
}

/**
 * Handlers used to modify app state (via a service) from within the module's container.
 * Similar to redux mapDispatchToProps.
 */
export interface IHandlers {
  handleSelectedChanged?: (selectedTableIds: string[], tables: ITableItem[], isManualJoin: boolean) => void;
  problemsCallback?: (problems: string[]) => void;
  onChangeByUser?: (ids: string[]) => void
}

export enum ManualJoinType {
  forceManualJoin = 'forceManualJoin',
  forceNoJoin = 'forceNoJoin'
}

export const classPrefix = 'TableSeater';
